<template>
  <router-link
    :to="computedTo"
    :active-class="activeClass"
    :exact-active-class="exactActiveClass"
    @mouseenter.native="$emit('mouseenter', $event)"
    @mouseleave.native="$emit('mouseleave', $event)"
    @touchstart.native="$emit('touchstart', $event)"
    @touchend.native="$emit('touchend', $event)"
    @click.native="$emit('click', $event)"
  >
    <slot />
  </router-link>
</template>

<script>
export default {
  props: {
    to: {
      type: [String, Object],
      required: true,
    },
    activeClass: {
      type: String,
      default: '',
    },
    exactActiveClass: {
      type: String,
      default: '',
    },
    hash: {
      type: String,
      default: null,
    },
  },
  computed: {
    computedTo() {
      if (typeof this.to === 'string') {
        return this.hash ? `${this.to}${this.hash}` : this.to;
      }

      if (typeof this.to === 'object' && this.hash) {
        return {
          ...this.to,
          hash: this.hash,
        };
      }

      return this.to;
    },
  },
};
</script>
